module.exports = __webpack_public_path__ + "static/7-2ae14040645313b5d929906b885f8d13.jpg";